import { Dialog } from "construct-ui";
import SiteSoldToShipToSpecialModel from "../../../models/site-management/site-sold-to-ship-to-special.model";
import ViewBase from "../../view-base.view";
import { exportExecutespExcelTemplate, downloadUserFileByFileID } from "../../../models/file.model"
import moment from "moment";
import { formats } from "../../../config/constants";

/**
 * Site Sold To Ship To Special Mapping- Excel Upload Dialog
 * 
 * The upload dialog used to download excel template and upload records to delete or update
 * 
 * @author cmcnkhiep
 */

export default function SiteSoldToShipToSpecialUploadDialog() {
    ViewBase.call(this);

    const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
    const ACCEPTED_FILE_FORMAT = '.xlsx';
    const FORM_ID = 'siteSoldToSpecialMappingExcelUploadForm';
    const UPLOAD_INPUT_ID = 'siteSoldToSpecialMappingExcelUploadInput';

    let errorMessage = '';

    let handleCloseDialog = (reload) => { }

    const downloadPurchaseOrdersExcelFormat = () => {
        this.showLoading();
        const fileName = "RepSoldToMappingTemplate";
        const exportConfig = {
            storedProcedureCode: "27",
            params: [],
            excelSheetNames: ["RepSoldToMap"]
        };
        exportExecutespExcelTemplate(exportConfig, fileName)
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    const upload = (e) => {
        e.preventDefault();
        if (!validate(e)) {
            e.stopPropagation();
            return;
        }

        this.showLoading();
        let file = document.querySelector(`#${UPLOAD_INPUT_ID}`).files[0];
        SiteSoldToShipToSpecialModel.uploadExcel(file)
            .then((result) => {
                this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('LT00000475', 'Success'), () => {
                    const fileId = result;
                    const fileName = `UploadResultRepSoldToMapping_${moment().format(formats.apiDateFormat)}`
                    downloadUserFileByFileID(fileId, fileName);
                    handleCloseDialog(true);
                });
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    }

    const validate = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
            errorMessage = this.getText('EM00000316', 'Please select a file');
            return false;
        }

        let fileUploadInput = document.querySelector(`#${UPLOAD_INPUT_ID}`);
        if (!fileUploadInput.files[0].name.endsWith(ACCEPTED_FILE_FORMAT)) {
            fileUploadInput.classList.add(BOOTSTRAP_INVALID_CLASS);
            errorMessage = this.getText('EM00000058', 'Invalid file.');
            return false;
        }

        // in the event where previously was incorrect and it's been corrected, remove the invalid class
        fileUploadInput.classList.remove(BOOTSTRAP_INVALID_CLASS);
        return true;
    }

    return {
        view: ({ attrs: { filters, isOpen, onClose } }) => {
            handleCloseDialog = onClose;
            return m(Dialog,
                {
                    isOpen,
                    onClose,
                    class: 'cui-dialog-l',
                    title: this.getText('LT00000761', 'Batch Upload approval'),
                    content: m('container',
                        m('ol',
                            m('li.fw-bold.mb-4',
                                m('.mb-2', this.getText('LT00000018', 'Excel Download')),
                                m('button.btn.btn-primary',
                                    {
                                        onclick: () => { downloadPurchaseOrdersExcelFormat(filters); }
                                    },
                                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                                    this.getText('LT00000218', 'Download Template')
                                ),
                            ),
                            m('hr'),
                            m('li.fw-bold.mb-4',
                                m('.mb-2', this.getText('LT00000197', 'Excel Upload')),
                                m('form.position-relative.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                                    m('input.form-control', { id: UPLOAD_INPUT_ID, type: 'file', accept: ACCEPTED_FILE_FORMAT, required: true }),
                                    m('.invalid-tooltip', errorMessage))
                            )
                        ),
                        this.getBaseViews()
                    ),
                    footer: m('.d-flex.gap-2.justify-content-end',
                        m('button.btn.btn-primary', { type: 'submit', form: FORM_ID }, this.getText("LT00000290", "Upload")),
                        m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
                    )
                }
            );
        }
    }
}
